var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.loading ? _c('p', [_c('Loading')], 1) : _vm._e(), _c('div', {
    staticClass: "page"
  }, [_vm.mission.title ? _c('div', {
    staticClass: "mission-name-header"
  }, [_vm._v(" " + _vm._s(_vm.mission.title) + " ")]) : _vm._e(), !_vm.token ? _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "field__label field--required"
  }, [_vm._v("分店代碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.branchCode,
      expression: "branchCode"
    }],
    staticClass: "field__input",
    attrs: {
      "placeholder": "請輸入分店代碼",
      "disabled": _vm.loading
    },
    domProps: {
      "value": _vm.branchCode
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.branchCode = $event.target.value;
      }
    }
  }), _c('small', {
    staticClass: "field__desc"
  }, [_vm._v("請輸入您的分店代碼以產生專屬 QR Code")])]), _c('SharedButton', {
    staticClass: "s-btn s-btn-bg-primary s-mt-3",
    attrs: {
      "disabled": _vm.loading || !_vm.branchCode
    },
    on: {
      "click": _vm.periodicallyGenerateQrCode
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? '產生中...' : '產生 QR Code') + " ")])], 1) : _c('div', [_c('b-card', {
    staticClass: "text-center p-4 mb-4",
    attrs: {
      "no-body": ""
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('vue-qr', {
    staticClass: "mx-auto",
    attrs: {
      "text": _vm.qrUrl,
      "size": 300
    }
  })], 1), _c('div', {
    staticClass: "mb-3"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("QR Code 將在 " + _vm._s(_vm.countdown) + " 秒後自動更新")])]), _c('SharedButton', {
    staticClass: "s-btn s-btn-bg-primary",
    attrs: {
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.refreshQrCode
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? '更新中...' : '立即更新 QRCode') + " ")])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }